module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av314-89959e66a0aab38c6d4dc39a5e923a46.jpg";